<template>
  <div class="page">
    <div class="list-page page-container">
      <div class="mod mod-detail">
        <template v-if="(status === 'OPEN' || status === 'CANCEL') && retry">
          <h3>预约回复</h3>
          <div class="retry">
            <p v-html="retry"></p>
          </div>
        </template>
        <h3>预约详情</h3>
        <div>
          <ul class="list-container">
            <li class="list-item flex-hb-vc" v-for="(item, name, index) in detailKeyMap" :key="index">
              <span>{{ detailKeyMap[name] }}</span>
              <span>{{ item | getValue(name, detail) }}</span>
            </li>
          </ul>
        </div>
        <div class="action flex-hb-vc">
          <a-button :class="status !== 'WC' ? 'full-btn' : 'half-btn'" size="large" type="primary" @click="goToList">返回</a-button>
          <a-button v-if="status === 'WC'" :class="status !== 'WC' ? 'full-btn' : 'half-btn'" size="large" type="primary" @click="onCancel">取消预约</a-button>
        </div>
        <div class="tips" v-if="status === 'WC'" v-html="tips"></div>
      </div>
    </div>
    <div class="loading-container" v-if="loading">
      <a-spin class="loading"/>
    </div>
  </div>
</template>
<script>
import { fetchGjpReservDetail, doGjpReservCancel } from '@/apis/customized'
import queryString from 'query-string'
import moment from 'moment'
import './index'

const detailKeyMap = {
  'passengerName': '乘客姓名',
  'segment': '预约航段',
  'reservMonth': '期望出行时间',
  'contactName': '联系人姓名',
  'contactPhone': '联系人手机号',
  'status': '预约状态'
}

const statusMap = {
  'WC': '已预约待确认',
  'OPEN': '航班开通已回复',
  'CANCEL': '航班取消已回复',
  'XX': '取消预约'
}

export default {
  data () {
    return {
      loading: false,
      detail: null,
      status: null,
      detailKeyMap,
      retry: null,
      tips: `
        <p>您的预约已提交成功，如航班开航，祥鹏航空将通知您进行航班预定，请您注意查收短信。</p>
      `
    }
  },
  created () {
    const params = queryString.parse((location.search), { decode: false })
    const { id } = params
    this.loading = true
    this.fetchDetailData(id)
  },
  methods: {
    async fetchDetailData (id) {
      const params = {
        reservId: id
      }
      const result = await fetchGjpReservDetail(params)
      this.detail = result || {}
      this.status = this.detail.status || null
      this.retry = this.detail.reservReply || ''
      this.loading = false
    },
    goToList () {
      history.go(-1)
    },
    onCancel () {
      const { detail } = this
      this.$modal.confirm({
        title: '温馨提示',
        content: '确定取消此国际航班的预约？',
        cancelText: '暂不取消',
        okText: '确认取消',
        onOk: () => {
          const params = {
            reservId: detail.id
          }
          doGjpReservCancel(params).then((result) => {
            if (result === true) {
              this.$modal.info({
                title: '温馨提示',
                content: '您已取消此国际航班的预约，如有需要，请重新预约。',
                okText: '确认',
                onOk: () => {
                  history.go(-1)
                }
              })
            }
          }).catch(e => {
            this.$message.error(e.message)
          })
        }
      })
    }
  },
  filters: {
    getValue (item, name, detail) {
      if (!detail) {
        return '-'
      }
      switch (name) {
        case 'segment':
          return `${detail.departurePortName} - ${detail.arrivalPortName}`
        case 'contactPhone':
          return `+${detail.contactAddr}-${detail.contactMobile}`
        case 'status':
          return statusMap[detail.status]
        case 'reservMonth':
          return moment(detail.reservMonth).format('YYYY-MM')
        default:
          return detail[name]
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
